import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/bus/busBudgetDetail/list',params);
    },
  
    add(params) {
      return common.post('/rocheManage/bus/busBudgetDetail/add',params);
    },
  
    edit(params) {
      return common.put('/rocheManage/bus/busBudgetDetail/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/bus/busBudgetDetail/delete',params);
    },
  
    deleteBatch(params) {
      return common.delete('/rocheManage/bus/busBudgetDetail/deleteBatch',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/bus/busBudgetDetail/exportXls', params, {responseType: 'blob'});
    },
    queryMainBudget(params) {
      return common.get('/rocheManage/bus/busBudgetMain/queryByEntity',params);
    },
  
    editMainBudget(params) {
      return common.put('/rocheManage/bus/busBudgetMain/edit',params);
    },

    importUrl4Excel(params) {
      return common.postForm('/rocheManage/bus/busBudgetDetail/importExcel', params);
    },
  
    importValidUrl4Excel(params) {
      return common.postForm('/rocheManage/bus/busBudgetDetail/importExcelValid', params);
    },
}


// WEBPACK FOOTER //
// ./src/api/bizmanagement/budget.js